import { render, staticRenderFns } from "./commonRecord.vue?vue&type=template&id=382a9587"
import script from "./commonRecord.vue?vue&type=script&lang=js"
export * from "./commonRecord.vue?vue&type=script&lang=js"
import style0 from "./commonRecord.vue?vue&type=style&index=0&id=382a9587&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports